import { Injectable } from '@angular/core';

import { RouteCodeEnum } from '@models/menu';

export const RoutesDictionaryByCode: Partial<Record<RouteCodeEnum, string>> = {
  // [RouteCodeEnum.ChangeOrder]: "",
  [RouteCodeEnum.CompanyProfile]: 'company-profile',
  [RouteCodeEnum.Contacts]: 'external-contacts',
  [RouteCodeEnum.Contracts]: 'contracts',
  [RouteCodeEnum.Correspondence]: 'emails',
  [RouteCodeEnum.Dashboard]: 'personal-dashboard',
  [RouteCodeEnum.Entity]: 'entities',
  [RouteCodeEnum.FileContractManager]: 'file-contract-manager',
  [RouteCodeEnum.FinancialSchedules]: 'financials',
  [RouteCodeEnum.Holidays]: 'holidays',
  [RouteCodeEnum.ListsManagement]: 'lists-management',
  [RouteCodeEnum.ManagementReports]: 'management-reports',
  [RouteCodeEnum.Maps]: 'maps',
  [RouteCodeEnum.Menu]: 'menu',
  [RouteCodeEnum.Modules]: 'modules',
  [RouteCodeEnum.MyCIPODrive]: 'my-drive',
  [RouteCodeEnum.Organizations]: 'organizations',
  [RouteCodeEnum.Payments]: 'payments',
  [RouteCodeEnum.PDFMarkup]: 'pdf-markup',
  [RouteCodeEnum.PowerBI]: 'reports',
  // [RouteCodeEnum.Programs]: "",
  // [RouteCodeEnum.Projects]: "",
  [RouteCodeEnum.ProgressPayment]: 'progresspayment', // Should be replaced to 'fn' after migration
  [RouteCodeEnum.Roles]: 'roles',
  [RouteCodeEnum.Schedules]: 'schedules',
  [RouteCodeEnum.SmartMap]: 'smartmap',
  [RouteCodeEnum.SOV]: 'sov',
  [RouteCodeEnum.TenantSettings]: 'tenant-settings',
  [RouteCodeEnum.Users]: 'users',
  [RouteCodeEnum.SysAdmin]: 'sys-admin',
};

export const HYBRID_MODULES = [-2, -10, -23];

// `dm` and `url` are route-type segments for dynamic/custom modules, not tied to any RouteCodeEnum
// value, since no menu code is associated with them.
export const DM_ROUTE_PART = 'dm';
export const URL_ROUTE_PART = 'url';

@Injectable()
export class LegacyRoutes {
  definition: LegacyRouteDefinition[] = [
    { code: 'e404', api: false, name: 'e404', folder: 'system', error: true },

    {
      code: 'SIGN',
      api: false,
      name: 'user_sign',
      route: '/user_sign?s',
      folder: 'core',
      properties: { system: true },
    },
    { code: 'WLC', api: false, name: 'welcome', folder: 'core' },
    { code: 'IDP', api: false, name: 'idp', folder: 'core' },
    { code: 'SM', api: true, name: 'smartmap', folder: 'core' },
    { code: 'PY', api: true, name: 'payments', folder: 'core' }, //OBSOLETE

    { code: 'M', api: true, name: 'modules', folder: 'admin' },
    { code: 'E', api: true, name: 'entities', folder: 'admin' },
    { code: 'MAPS', api: true, name: 'maps', folder: 'admin' },

    // When deleting this, be aware to replace the route to 'fn' in RoutesDictionaryByCode
    {
      code: 'DYN-PP',
      api: true,
      name: 'progresspayment',
      folder: 'core',
      route: '/progresspayment/:contractId/:periodId/:entityInstanceId?sovEid',
    },
  ];

  list: LegacyRouteDefinition[] = [];
  systemList: LegacyRouteDefinition[] = [];
  appList: LegacyRouteDefinition[] = [];
  byCode: Map<string, LegacyRouteDefinition> = new Map<string, LegacyRouteDefinition>();

  constructor() {
    this.init();
  }

  init() {
    for (let i = 0; i < this.definition.length; i++) {
      const r = this.definition[i];
      if (r.name) {
        r.route = r.route || '/' + r.name;
        r.controller = r.controller || r.name;
        r.view = r.view || r.name;
        r.folder = r.folder || r.name;

        if (!r.properties) {
          r.properties = {};
        }

        this.list.push(r);
        if (r.properties.system) {
          this.systemList.push(r);
        } else {
          this.appList.push(r);
        }
      }
    }

    for (let j = 0; j < this.list.length; j++) {
      if (this.list[j].code) {
        this.byCode.set(this.list[j].code, this.list[j]);
      }
    }
  }
}

export interface LegacyRouteDefinition {
  code: string;
  api: boolean;
  name: string;
  folder: string;
  route?: string;
  controller?: string;
  view?: string;
  error?: boolean;
  properties?: LegacyRouteDefinitionProperties;
}

export interface LegacyRouteDefinitionProperties {
  system?: boolean;
  code?: string;
  error?: boolean;
  reloadOnSearch?: boolean;
}
